import { MessageSquareText, Gauge, Link2, FileSpreadsheet } from "lucide-react";
import { Reveal } from "./Reveal";

const CARDS = [
  {
    id: "benefit-card-whatsapp",
    icon: MessageSquareText,
    title: "WhatsApp nativo",
    body: "Mensajes personalizados con tu nombre y tu tono. Nada de plantillas frías: tus clientes sienten que les escribes tú, no un robot. Sin sonar a spam, sin números desconocidos.",
    span: "lg:col-span-3",
    accent: "emerald",
  },
  {
    id: "benefit-card-risk-indicator",
    icon: Gauge,
    title: "Semáforo de riesgo",
    body: "Anticipa quién se va a retrasar antes de que pase, según su historial de pagos.",
    span: "lg:col-span-3",
    accent: "orange",
  },
  {
    id: "benefit-card-payment-links",
    icon: Link2,
    title: "Links de pago integrados",
    body: "Yape, Plin, Mercado Pago y Stripe dentro del mismo recordatorio. Tu cliente paga en dos toques, sin excusas.",
    span: "lg:col-span-2",
    accent: "emerald",
  },
  {
    id: "benefit-card-reports",
    icon: FileSpreadsheet,
    title: "Reportes en 1 clic",
    body: "Exporta todo para tu contador en segundos: cobrado, pendiente y vencido, listo para declarar.",
    span: "lg:col-span-4",
    accent: "orange",
  },
];

export const Benefits = () => (
  <section id="beneficios" data-testid="benefits-section" className="mx-auto max-w-6xl px-4 py-24 sm:px-6 lg:py-32">
    <Reveal>
      <p className="mono mb-4 text-xs uppercase tracking-[0.2em] text-emerald-400">Beneficios</p>
      <h2 className="font-display max-w-2xl text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-4xl">
        Menos persecución. Más dinero en tu cuenta.
      </h2>
    </Reveal>

    <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-6">
      {CARDS.map((c, i) => (
        <Reveal key={c.id} delay={i * 0.08} className={c.span}>
          <article
            data-testid={c.id}
            className={`group h-full rounded-2xl border border-white/10 bg-[#131316]/70 p-7 backdrop-blur-sm transition-all duration-500 hover:-translate-y-1 ${
              c.accent === "emerald"
                ? "hover:border-emerald-500/40 hover:shadow-[0_20px_60px_-20px_rgba(16,185,129,0.25)]"
                : "hover:border-orange-500/40 hover:shadow-[0_20px_60px_-20px_rgba(249,115,22,0.2)]"
            }`}
          >
            <span
              className={`mb-5 inline-flex h-11 w-11 items-center justify-center rounded-xl transition-transform duration-500 group-hover:scale-110 ${
                c.accent === "emerald" ? "bg-emerald-500/15 text-emerald-400" : "bg-orange-500/15 text-orange-400"
              }`}
            >
              <c.icon className="h-5 w-5" />
            </span>
            <h3 className="font-display text-lg font-semibold tracking-tight">{c.title}</h3>
            <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{c.body}</p>
          </article>
        </Reveal>
      ))}
    </div>
  </section>
);
